import {applyMiddleware, createStore as _createStore} from 'redux'
import {persistCombineReducers, persistStore} from 'redux-persist'
import {composeWithDevTools} from 'redux-devtools-extension'
import storage from 'redux-persist/lib/storage'
import reducers from './reducers'


export default function createStore() {


    const reducer = persistCombineReducers(
        {
            key: 'root',
            storage,
            whitelist: [
                'credentials',
                'person',

            ]
        },
        reducers
    )


    const store = _createStore(
        reducer,
        composeWithDevTools(
            applyMiddleware(
            )
        ))


    const persistor = persistStore(store)

    return {store, persistor}
}


// WEBPACK FOOTER //
// ./src/redux/create-store.js